import React, { Component } from 'react';
import { SelectInput, TextInput, SelectArrayInput, UPDATE } from 'react-admin';
import {
  FormControl,
  Grid,
  Typography,
  Button,
  Paper,
  CircularProgress,
} from '@material-ui/core';
import { SaveOutlined } from '@material-ui/icons';
import dataProvider from '../../../dataProvider';
import { isRequired } from '../../../validators';
import { NEW_SEGMENT } from '../constants';

const valuesNotRequired = ['blank', 'blank_not'];

class AudienceSegmentSection extends Component {
  constructor(props) {
    super(props);
    this.state = {
      segmentConditions: [
        {
          types: this.props.audienceSegmentOptions.types,
          ops: [],
          values: [],
        },
      ],
      conditionsMessage: '',
      isValidatingCondition: false,
    };
  }

  componentDidMount() { }

  getConditionType = (event) => {
    const { audienceSegmentOptions } = this.props;
    const id = this.eventToString(event);
    return audienceSegmentOptions.types.filter(t => t.id === id)[0];
  }

  eventToString = event => Object.keys(event).map((e) => {
    if (typeof event[e] === 'function') { // preventDefault (fn) => null
      return '';
    }
    return event[e];
  }).join('')

  handleTypeChange = index => async (event) => {
    const newConditions = this.state.segmentConditions.map((condition, idx) => {
      if (index === idx) {
        const type = this.getConditionType(event);
        return {
          ...condition,
          isMultiSelect: type.isMultiSelect,
          ops: type.ops,
          values: type.values,
          isValueRequired: true,
        };
      }
      return condition;
    });
    this.setState({
      segmentConditions: newConditions,
    });
  }

  handleOpChange = index => async (event) => {
    const { conditionOp0, conditionOp1, conditionOp2 } = this.props;
    const eventValue = this.eventToString(event);
    await this.sendSegmentDataToServer(index, 'CONDITION_OP', eventValue);
    const newConditions = this.state.segmentConditions.map((condition, idx) => {
      let conditionResult = {
        ...condition,
        isValueRequired: true,
      };
      if (index === idx && valuesNotRequired.includes(eventValue)) {
        conditionResult = {
          ...conditionResult,
          isValueRequired: false,
        };
      } else if (index !== idx && idx === 0 && valuesNotRequired.includes(conditionOp0)) {
        conditionResult = {
          ...conditionResult,
          isValueRequired: false,
        };
      } else if (index !== idx && idx === 1 && valuesNotRequired.includes(conditionOp1)) {
        conditionResult = {
          ...conditionResult,
          isValueRequired: false,
        };
      } else if (index !== idx && idx === 2 && valuesNotRequired.includes(conditionOp2)) {
        conditionResult = {
          ...conditionResult,
          isValueRequired: false,
        };
      }
      return {
        ...conditionResult,
      };
    });
    this.setState({
      segmentConditions: newConditions,
    });
  }

  handleValueChange = index => (event) => {
    this.sendSegmentDataToServer(index, 'CONDITION_VALUE', event.target.value);
  }

  addSegmentCondition = () => {
    const { segmentConditions } = this.state;
    const { audienceSegmentOptions } = this.props;
    segmentConditions.push({
      types: audienceSegmentOptions.types,
      ops: [],
      values: [],
    });
    this.setState({
      segmentConditions,
    });
  }

  sendSegmentDataToServer = async (index, eventSource, eventValue, fn, conditionIndexToRemove) => {
    const {
      id,
      listId,
      emailTemplateId,
      segmentType,
      match,
      conditionType0,
      conditionOp0,
      conditionValue0,
      conditionType1,
      conditionOp1,
      conditionValue1,
      conditionType2,
      conditionOp2,
      conditionValue2,
      audienceSegmentOptions,
    } = this.props;

    let targetConditionOp;
    let targetConditionValue;
    if (eventSource === 'CONDITION_OP') {
      targetConditionOp = eventValue;
      targetConditionValue = null;
    } if (eventSource === 'CONDITION_VALUE') {
      targetConditionValue = eventValue;
    }

    let conditions;
    let availableConditions = [];
    if (!conditionIndexToRemove) {
      conditions = [conditionType0, conditionType1, conditionType2].map(p => audienceSegmentOptions.types.find(t => t.id === p));
      availableConditions = conditions.filter((p, idx) => idx === index).map((c) => {
        let temp;
        if (index === 0) {
          temp = {
            op: targetConditionOp || conditionOp0,
            value: targetConditionValue || conditionValue0,
          };
        }
        if (index === 1) {
          temp = {
            op: targetConditionOp || conditionOp1,
            value: targetConditionValue || conditionValue1,
          };
        }
        if (index === 2) {
          temp = {
            op: targetConditionOp || conditionOp2,
            value: targetConditionValue || conditionValue2,
          };
        }
        return {
          condition_type: c.type,
          op: temp.op,
          field: c.field,
          value: temp.value,
        };
      });
      this.setState({
        isValidatingCondition: true,
      });
    }
    dataProvider(UPDATE, 'offeringCampaigns', {
      id,
      action: 'evaluate-audience-segment-condition',
      resource: 'offeringCampaigns',
      data: {
        emailTemplateId,
        audience: {
          id: listId,
          segment: {
            conditionIndexToRemove,
            nextConditionIndex: index,
            type: segmentType,
            match,
            conditions: segmentType === NEW_SEGMENT ? availableConditions : [],
          },
        },
      },
    }).then((res) => {
      if (typeof fn === 'function') {
        fn(index);
      }
      if (res) {
        this.setState({
          isValidatingCondition: false,
          conditionsMessage: res.data.segmentValidationMsg,
        });
      }
    })
      .catch((e) => {
        let localContent = e;
        if (e.body) {
          const body = JSON.parse(e.body);
          if (body.error.validationErrors) {
            localContent = `Errors: ${JSON.stringify(Object.values(body.error.validationErrors))}`;
          } else {
            localContent = `Error:${body.error.message}`;
          }
        }
        this.setState({
          isValidatingCondition: false,
          conditionsMessage: localContent,
        });
      });
  }

  updateSegmentConditions = (index) => {
    const { segmentConditions } = this.state;
    segmentConditions.splice(index, 1);
    this.setState({
      segmentConditions,
    });
  }

  removeSegmentCondition = index => () => {
    const { segmentConditions } = this.state;
    if (segmentConditions.length > 1) {
      this.sendSegmentDataToServer(index, null, null, this.updateSegmentConditions, index);
    }
  }

  render() {
    const {
      segmentConditions,
      conditionsMessage,
      isValidatingCondition,
    } = this.state;

    const { audienceSegmentOptions, segmentType } = this.props;

    return (
      segmentType === NEW_SEGMENT && (
        <Grid container direction="column" justify="space-between" alignItems="baseline" spacing={3} style={{ marginBottom: 20 }}>
          <Grid container direction="row" justify="flex-start" alignItems="baseline" item xs={12}>
            <Grid item xs={6} sm={3} />
            <Grid item xs={6} sm={6}>
              <Paper> {conditionsMessage} </Paper>
            </Grid>
            <Grid item xs={6} sm={3} />
          </Grid>
          <Grid container direction="row" justify="flex-start" alignItems="baseline" item xs={12}>
            <Grid item xs={6} sm={2}>
              <Typography color="textSecondary">Contacts match</Typography>
            </Grid>
            <Grid item xs={6} sm={2}>
              <FormControl>
                <SelectInput
                  source="match"
                  choices={audienceSegmentOptions.matches}
                  optionText={choice => choice.name}
                  validate={isRequired}
                />
              </FormControl>
            </Grid>
            <Grid item xs={6} sm={2}>
              <Typography color="textSecondary">of the following conditions:</Typography>
            </Grid>
          </Grid>
          {
            segmentConditions.map((condition, index) => (
              <Grid container direction="row" justify="flex-start" alignItems="baseline" item xs={12}>
                <Grid item xs={8} sm={2}>
                  <FormControl style={{ minWidth: 50 }}>
                    <SelectInput
                      label="Type"
                      source={`conditionType${index}`}
                      choices={condition.types}
                      optionText={choice => choice.name}
                      onChange={this.handleTypeChange(index)}
                      validate={isRequired}
                      disabled={isValidatingCondition}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={2}>
                  <FormControl style={{ minWidth: 50 }}>
                    <SelectInput
                      label="Op"
                      source={`conditionOp${index}`}
                      choices={condition.ops}
                      optionText={choice => choice.name}
                      onChange={this.handleOpChange(index)}
                      validate={isRequired}
                      disabled={isValidatingCondition}
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={2}>
                  <FormControl style={{ minWidth: 50 }}>
                    {
                      condition && condition.isMultiSelect && (
                        <SelectArrayInput
                          label="Values"
                          source={`conditionValue${index}`}
                          choices={condition.values}
                          optionText={choice => choice.name}
                          validate={isRequired}
                          options={{ fullWidth: true }}
                          displayEmpty
                          // disabled={isValidatingCondition}
                        />
                      )
                    }
                    {
                      condition && !condition.isMultiSelect && condition.isValueRequired && condition.values.length > 0 ? (
                        <SelectInput
                          label="Value"
                          source={`conditionValue${index}`}
                          choices={condition.values}
                          onChange={this.handleValueChange(index)}
                          validate={isRequired}
                          optionText={choice => choice.name}
                          // disabled={isValidatingCondition}
                        />
                      ) : condition && !condition.isMultiSelect &&
                      condition.isValueRequired &&
                      <TextInput label="Value" source={`conditionValue${index}`} onChange={this.handleValueChange(index)} validate={isRequired} />
                    }
                  </FormControl>
                </Grid>
                <Grid item xs={8} sm={2}>
                  <Button disabled={isValidatingCondition} variant="outlined" color="secondary" onClick={this.removeSegmentCondition(index)} spacing={1}>
                    {
                      isValidatingCondition ? (
                        <React.Fragment>
                          <CircularProgress
                            size={15}
                            style={{
                              width: '15px',
                              height: '15px',
                              marginRight: '15px',
                              color: 'white',
                          }}
                          />
                          Remove Condition
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <SaveOutlined style={{ marginRight: 5 }} />
                          Remove Condition
                        </React.Fragment>
                      )
                    }
                  </Button>
                </Grid>
              </Grid>
          ))
          }
          {
            segmentConditions.length < 3 && (
              <Grid container direction="row" justify="flex-start" alignItems="baseline" item xs={12} >
                <Button disabled={isValidatingCondition} variant="outlined" color="secondary" onClick={this.addSegmentCondition} spacing={1}>
                  {
                      isValidatingCondition ? (
                        <React.Fragment>
                          <CircularProgress
                            size={15}
                            style={{
                              width: '15px',
                              height: '15px',
                              marginRight: '15px',
                              color: 'white',
                          }}
                          />
                          Add Condition
                        </React.Fragment>
                      ) : (
                        <React.Fragment>
                          <SaveOutlined style={{ marginRight: 5 }} />
                          Add Condition
                        </React.Fragment>
                      )
                    }
                </Button>
              </Grid>
            )
          }
        </Grid>
      )
    );
  }
}

export default AudienceSegmentSection;



// WEBPACK FOOTER //
// ./src/components/OfferCampaign/Partials/AudienceSegmentSection.js